import { Getter, GetterTree } from 'vuex'
import { State } from './state'

export function loggedIn (state: State): boolean {
    return (state.accessToken) ? true : false;
}

export function authenticationError(state: State): boolean {
    return (state.authenticationError.status != 0);
}

export function authenticationErrorStatus (state: State): number {
    return state.authenticationError.status;
}

export function authenticationErrorMessage (state: State): string {
    return state.authenticationError.message
}

export function authenticating (state: State): boolean {
    return state.authenticating
}


export default <GetterTree<State, any>> {
    loggedIn, authenticationError, authenticationErrorStatus, authenticationErrorMessage, authenticating
}
